import * as React from 'react';
import { SVGProps } from 'react';

const IconFileAnimationSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 15.465a4 4 0 1 1 0-6.93A3.981 3.981 0 0 1 12 8c.729 0 1.412.195 2 .535a4 4 0 1 1 0 6.93A3.982 3.982 0 0 1 12 16a3.982 3.982 0 0 1-2-.535ZM12 12c0-1.081.429-2.062 1.126-2.782A2.992 2.992 0 0 0 12 9a2.992 2.992 0 0 0-2 .764c-.614.55-1 1.348-1 2.236a2.992 2.992 0 0 0 1.874 2.782c.348.14.728.218 1.126.218.398 0 .778-.078 1.126-.218A3.987 3.987 0 0 1 12 12Zm-2.874 2.782a3 3 0 1 1 0-5.563A3.987 3.987 0 0 0 8 12c0 1.081.429 2.062 1.126 2.782Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 3H2v18h20V3ZM3 20V4h18v16H3Z"
    />
  </svg>
);
export default IconFileAnimationSizeM;
